import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import moment from 'moment';
import YearSelect from './YearSelect';
export var MonthYearPickerOutputFormat;
(function (MonthYearPickerOutputFormat) {
    MonthYearPickerOutputFormat["moment"] = "moment";
    MonthYearPickerOutputFormat["date"] = "date";
    MonthYearPickerOutputFormat["object"] = "object";
})(MonthYearPickerOutputFormat || (MonthYearPickerOutputFormat = {}));
export var MonthYearPickerMonthFormat;
(function (MonthYearPickerMonthFormat) {
    MonthYearPickerMonthFormat["M"] = "M";
    MonthYearPickerMonthFormat["MM"] = "MM";
    MonthYearPickerMonthFormat["MMM"] = "MMM";
    MonthYearPickerMonthFormat["MMMM"] = "MMMM";
})(MonthYearPickerMonthFormat || (MonthYearPickerMonthFormat = {}));
const parseValue = (value) => {
    if (value === null || value === undefined)
        return { year: null, month: 0 };
    if (value instanceof Date)
        return { year: value.getFullYear(), month: value.getMonth() };
    if (moment.isMoment(value))
        return { year: value.year(), month: value.month() };
    if (typeof value.year === 'number' && typeof value.month === 'number')
        return { year: value.year, month: value.month };
    return { year: null, month: 0 };
};
export const displayDayMonth = (value, monthFormat = 'MMMM') => {
    const date = parseValue(value);
    return moment({ year: date.year, month: date.month, day: 1 }).format(`${monthFormat} YYYY`);
};
const MonthYearPicker = ({ value, onChange, outputType = MonthYearPickerOutputFormat.object, monthFormat = MonthYearPickerMonthFormat.MMMM, onBlur = () => { }, onKeyDown = () => { }, disabled = false, yearsInPast, yearsInFuture, }) => {
    const [innerValue, setInnerValue] = useState(parseValue(value));
    useEffect(() => {
        const { year: oldYear, month: oldMonth } = parseValue(innerValue);
        const newValue = parseValue(value);
        const { year: newYear, month: newMonth } = newValue;
        if (oldYear !== newYear || oldMonth !== newMonth) {
            setInnerValue(newValue);
        }
    }, [value]);
    const submitValue = (force = false) => {
        const { year, month } = innerValue;
        const oldValue = parseValue(value);
        if (Number.isNaN(year) || year === null) {
            if (force || value)
                onChange(null);
            return;
        }
        if (!force) {
            if (oldValue.year === year && oldValue.month === month)
                return;
        }
        if (outputType === 'object')
            onChange(Object.assign({}, innerValue));
        else if (outputType === 'date')
            onChange(new Date(year, month, 1));
        else if (outputType === 'moment')
            onChange(moment.utc({ year: year, month, day: 1 }));
    };
    useEffect(() => {
        submitValue();
    }, [innerValue]);
    const monthOptions = useMemo(() => {
        const m = [];
        for (let i = 0; i < 12; i += 1)
            m.push(_jsx("option", Object.assign({ value: i }, { children: moment({ year: 2000, month: i, day: 1 }).format(monthFormat) }), i));
        return m;
    }, [monthFormat]);
    const handleOutsideClick = () => {
        submitValue();
        onBlur();
    };
    const changeYear = year => {
        setInnerValue(oldValue => (Object.assign(Object.assign({}, oldValue), { year })));
        submitValue();
    };
    const changeMonth = e => {
        const month = parseInt(e.target.value, 10) || 0;
        setInnerValue(oldValue => (Object.assign(Object.assign({}, oldValue), { month })));
        submitValue();
    };
    return (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: handleOutsideClick }, { children: _jsxs("div", Object.assign({ className: "react-month-year-picker input-group horizontal-form" }, { children: [_jsx("select", Object.assign({ value: innerValue.month, className: "form-control month-input", onChange: changeMonth, onKeyDown: onKeyDown, disabled: disabled, name: "month" }, { children: monthOptions })), _jsx(YearSelect, { value: innerValue.year, onChange: changeYear, yearsInPast: yearsInPast, yearsInFuture: yearsInFuture, onKeyDown: onKeyDown, disabled: disabled, required: true, name: "year", className: "form-control year-input" })] })) })));
};
export default MonthYearPicker;
